import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLoadingStore } from "../../store/loadingStore";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import Portal from "@mui/material/Portal";

const GlobalLoader: React.FC = () => {
  const { isLoading, setLoading } = useLoadingStore();
  const location = useLocation();

  // 現在のURLパスから、サイドバーが「ない」画面（ログイン・サインアップなど）を判定
  const isAuthPage =
    location.pathname.includes("/auth/") ||
    location.pathname.includes("/update-password") ||
    location.pathname === "/";

  useEffect(() => {
    // apiFetch.ts から発行される CustomEvent を受け取る
    const handleToggleLoading = (e: Event) => {
      const customEvent = e as CustomEvent;
      if (typeof customEvent.detail?.show === "boolean") {
        setLoading(customEvent.detail.show);
      }
    };

    window.addEventListener("toggle-loading", handleToggleLoading);

    // クリーンアップ
    return () => {
      window.removeEventListener("toggle-loading", handleToggleLoading);
    };
  }, [setLoading]);

  return (
    <Portal>
      <Backdrop
        open={isLoading}
        sx={{
          color: "#fff",
          zIndex: 9999, // サイドバーやヘッダーよりも確実に一番上に表示させる
          backgroundColor: "transparent",
          position: "fixed", // 画面に対して強制的に固定
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          paddingLeft: {
            xs: 0, // モバイル・タブレット（サイドバーが隠れる幅）では常に余白なし
            lg: isAuthPage ? 0 : "250px", // PC画面：ログイン系は0、ログイン後はサイドバーの幅(250px)だけずらす
          },
        }}
      >
        <CircularProgress color="info" size="3rem" />
      </Backdrop>
    </Portal>
  );
};

export default GlobalLoader;